import './Home.scss';
import Component from './Home.js';
export default Component;
